import InfoForm from "./_components/InfoForm";

function Info() {
  return (
    <div className="flex h-full justify-center bg-cool-gray-50">
      <div className="mt-16">
        <InfoForm />
      </div>
    </div>
  );
}

export default Info;
